import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

/** Screen names by the first URL segment; a route's own `title` wins. */
const SECTION_TITLES: Record<string, string> = {
  dashboard: 'Dashboard',
  accounts: 'Accounts',
  transactions: 'Transactions',
  budgets: 'Budgets',
  categories: 'Categories',
  goals: 'Goals',
  plan: 'Plan',
  payments: 'Bills & Income',
  insights: 'Insights',
  'debt-plan': 'Debt Payoff Plan',
  hashtags: 'Hashtags',
  merchants: 'Merchants',
  settings: 'Settings',
  support: 'Support',
  start: 'Get Started',
  blocked: 'Subscription',
  stripeCheckout: 'Checkout',
  validationemail: 'Email Verification',
  'sign-in': 'Log In To Your Dashboard',
  'sign-up': 'Sign Up',
  'forgot-password': 'Forgot Password',
  'reset-password': 'Reset Password',
};

const BRAND = 'PocketGuard';

/**
 * The tab said "PocketGuard | Log In To Your Dashboard" on every screen, signed
 * in or not, because `index.html` set it once and nothing updated it (QA audit
 * #2, A5/U1). The section comes from the URL so no route table needs a title;
 * a route that does declare one is respected.
 */
@Injectable({ providedIn: 'root' })
export class PageTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const own = this.buildTitle(snapshot);
    const section =
      SECTION_TITLES[snapshot.url.split('?')[0].split('/')[1] ?? ''];
    const name = own ?? section;
    this.title.setTitle(name ? `${BRAND} | ${name}` : BRAND);
  }
}
